module.exports = __webpack_public_path__ + "media/bubble.640be347.mp3";